import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { User } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type UpdateUserInput = {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  locale?: string;
  timezone?: string;
  customFields?: Record<string, unknown>;
};

export const useUpdateUser = (
  projectId: string,
  userExternalId: string,
  options: Omit<UseMutationOptions<User, UnprocessableEntityError, UpdateUserInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<User, UnprocessableEntityError, UpdateUserInput, unknown>({
    mutationFn: async (input: UpdateUserInput): Promise<User> => {
      const response = await api.patch<User>(`/projects/${projectId}/users/${userExternalId}`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users", userExternalId],
      });
    },
    ...options
  });
};
